"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _propTypes = require("../prop-types");

var _utils = require("../utils");

var _View = _interopRequireDefault(require("./View"));

var _Spacer = _interopRequireDefault(require("./Spacer"));

var _core = require("@emotion/core");

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var isColumnLayout = function isColumnLayout(flexDirection) {
  return ['column', 'column-reverse'].includes(flexDirection);
};

// joinChildren will add extra Spacers if a child returns null, as
// React.children cannot filter these out. To avoid it, we do not
// display consecutive spacers
var GapSpacerBase = (
/*#__PURE__*/
0, _styledBase.default)(_Spacer.default, {
  target: "e1s41o6r0"
})(process.env.NODE_ENV === "production" ? {
  name: "jek2it",
  styles: "& + &{display:none;}"
} : {
  name: "jek2it",
  styles: "& + &{display:none;}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9zdWJtb2R1bGVzL2xheW91dC9GbGV4LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUEwQm9DIiwiZmlsZSI6Ii4uLy4uLy4uL3NyYy9zdWJtb2R1bGVzL2xheW91dC9GbGV4LnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCwgeyBDb21wb25lbnRUeXBlIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuXG5pbXBvcnQgeyBkZXNjcmliZSwgUHJvcFR5cGVzIH0gZnJvbSAnQGFtem4vc3RlbmNpbC1yZWFjdC1kZXNjJztcblxuaW1wb3J0IHsgY3NzVmFsdWUgfSBmcm9tICcuLi9wcm9wLXR5cGVzJztcbmltcG9ydCB7XG4gIGpvaW5DaGlsZHJlbixcbiAgd2l0aFRlc3RBdHRyaWJ1dGVzLFxuICBTdHlsZWRGb3J3YXJkaW5nUmVmQ29tcG9uZW50XG59IGZyb20gJy4uL3V0aWxzJztcblxuaW1wb3J0IFZpZXcsIHsgVmlld1Byb3BzIH0gZnJvbSAnLi9WaWV3JztcbmltcG9ydCBTcGFjZXIgZnJvbSAnLi9TcGFjZXInO1xuXG5jb25zdCBpc0NvbHVtbkxheW91dCA9IChmbGV4RGlyZWN0aW9uOiBzdHJpbmcpID0+XG4gIFsnY29sdW1uJywgJ2NvbHVtbi1yZXZlcnNlJ10uaW5jbHVkZXMoZmxleERpcmVjdGlvbik7XG5cbmludGVyZmFjZSBHYXBTcGFjZXJQcm9wcyB7XG4gIGZsZXhEaXJlY3Rpb246IHN0cmluZztcbiAgZ3JpZEdhcDogbnVtYmVyIHwgc3RyaW5nO1xufVxuXG4vLyBqb2luQ2hpbGRyZW4gd2lsbCBhZGQgZXh0cmEgU3BhY2VycyBpZiBhIGNoaWxkIHJldHVybnMgbnVsbCwgYXNcbi8vIFJlYWN0LmNoaWxkcmVuIGNhbm5vdCBmaWx0ZXIgdGhlc2Ugb3V0LiBUbyBhdm9pZCBpdCwgd2UgZG8gbm90XG4vLyBkaXNwbGF5IGNvbnNlY3V0aXZlIHNwYWNlcnNcbmNvbnN0IEdhcFNwYWNlckJhc2UgPSBzdHlsZWQoU3BhY2VyKWBcbiAgJiArICYge1xuICAgIGRpc3BsYXk6IG5vbmU7XG4gIH1cbmA7XG5cbmNvbnN0IEdhcFNwYWNlcjogUmVhY3QuRkM8R2FwU3BhY2VyUHJvcHM+ID0gKHsgZmxleERpcmVjdGlvbiwgZ3JpZEdhcCB9KSA9PiB7XG4gIGNvbnN0IHNpemVQcm9wID0ge1xuICAgIFtpc0NvbHVtbkxheW91dChmbGV4RGlyZWN0aW9uKSA/ICdoZWlnaHQnIDogJ3dpZHRoJ106IGdyaWRHYXBcbiAgfTtcblxuICByZXR1cm4gPEdhcFNwYWNlckJhc2UgZmxleD1cIjAgMCBhdXRvXCIgey4uLnNpemVQcm9wfSAvPjtcbn07XG5cbmV4cG9ydCBpbnRlcmZhY2UgRmxleFByb3BzIGV4dGVuZHMgVmlld1Byb3BzIHtcbiAgZ3JpZEdhcD86IG51bWJlciB8IHN0cmluZztcbiAgZmxleERpcmVjdGlvbjogc3RyaW5nO1xuICBjb250YWluZXI/OiBDb21wb25lbnRUeXBlPFZpZXdQcm9wcz47XG59XG5cbmNvbnN0IEZsZXhCYXNlID0gUmVhY3QuZm9yd2FyZFJlZjxIVE1MRGl2RWxlbWVudCwgRmxleFByb3BzPihcbiAgKFxuICAgIHtcbiAgICAgIGdyaWRHYXAsXG4gICAgICBmbGV4RGlyZWN0aW9uLFxuICAgICAgY2hpbGRyZW4sXG4gICAgICBjb250YWluZXI6IENvbnRhaW5lciA9IFZpZXcsXG4gICAgICAuLi5vdXRlclByb3BzXG4gICAgfSxcbiAgICByZWZcbiAgKSA9PiAoXG4gICAgPENvbnRhaW5lclxuICAgICAgZGlzcGxheT1cImZsZXhcIlxuICAgICAgcmVmPXtyZWZ9XG4gICAgICBmbGV4RGlyZWN0aW9uPXtmbGV4RGlyZWN0aW9ufVxuICAgICAgey4uLm91dGVyUHJvcHN9PlxuICAgICAge2dyaWRHYXBcbiAgICAgICAgPyBqb2luQ2hpbGRyZW4oXG4gICAgICAgICAgICBjaGlsZHJlbixcbiAgICAgICAgICAgIDxHYXBTcGFjZXIgZmxleERpcmVjdGlvbj17ZmxleERpcmVjdGlvbn0gZ3JpZEdhcD17Z3JpZEdhcH0gLz5cbiAgICAgICAgICApXG4gICAgICAgIDogY2hpbGRyZW59XG4gICAgPC9Db250YWluZXI+XG4gIClcbik7XG5cbi8vIEZvcmNlIFRTIHRvIGFjY2VwdCAud2l0aENvbXBvbmVudFxuY29uc3QgRmxleFN0eWxlZCA9IEZsZXhCYXNlIGFzIFN0eWxlZEZvcndhcmRpbmdSZWZDb21wb25lbnQ8RmxleFByb3BzPjtcblxuRmxleFN0eWxlZC53aXRoQ29tcG9uZW50ID0gKHRhZzogYW55KSA9PiB7XG4gIGNvbnN0IENvbnRhaW5lciA9IFZpZXcud2l0aENvbXBvbmVudCh0YWcpO1xuICByZXR1cm4gUmVhY3QuZm9yd2FyZFJlZjxhbnksIEZsZXhQcm9wcz4oKHByb3BzLCByZWYpID0+IChcbiAgICA8RmxleEJhc2Ugey4uLnByb3BzfSByZWY9e3JlZn0gY29udGFpbmVyPXtDb250YWluZXJ9IC8+XG4gICkpIGFzIGFueTtcbn07XG5cbmNvbnN0IEZsZXhCYXNlV2l0aERvY3MgPSBkZXNjcmliZShGbGV4U3R5bGVkKS5kZXNjcmlwdGlvbihcbiAgJ1ZpZXcgYmFzZWQgb24gZmxleCB1c2VkIGZvciBpbXBsZW1lbnRpbmcgbGF5b3V0cy4nXG4pO1xuXG5GbGV4QmFzZVdpdGhEb2NzLnByb3BUeXBlcyA9IHtcbiAgLi4uVmlldy5kZXNjcmliZWRQcm9wVHlwZXMsXG4gIGZsZXhEaXJlY3Rpb246IFByb3BUeXBlcy5zdHJpbmcuZGVzY3JpcHRpb24oXG4gICAgXCJTZXRzIHRoZSBDU1MgJ2ZsZXgtZGlyZWN0aW9uJyBwcm9wZXJ0eSBmb3IgdGhlIGVsZW1lbnQuXCJcbiAgKS5pc1JlcXVpcmVkLFxuICBncmlkR2FwOiBjc3NWYWx1ZSgpLmRlc2NyaXB0aW9uKCdTcGFjaW5nIGJldHdlZW4gZWFjaCBjaGlsZC4nKSxcbiAgY2hpbGRyZW46IFByb3BUeXBlcy5ub2RlLmRlc2NyaXB0aW9uKCdFbGVtZW50cyB0byBsYXkgb3V0IGhvcml6b250YWxseS4nKVxufTtcblxuY29uc3QgRmxleCA9IHdpdGhUZXN0QXR0cmlidXRlcyh7XG4gIGNvbXBvbmVudDogJ1N0ZW5jaWxSZWFjdEZsZXgnXG59KShGbGV4QmFzZVdpdGhEb2NzKTtcblxuRmxleC5kaXNwbGF5TmFtZSA9ICdGbGV4JztcblxuZXhwb3J0IGRlZmF1bHQgRmxleDtcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

var GapSpacer = function GapSpacer(_ref) {
  var flexDirection = _ref.flexDirection,
      gridGap = _ref.gridGap;
  var sizeProp = (0, _defineProperty2.default)({}, isColumnLayout(flexDirection) ? 'height' : 'width', gridGap);
  return (0, _core.jsx)(GapSpacerBase, (0, _extends2.default)({
    flex: "0 0 auto"
  }, sizeProp));
};

var FlexBase = _react.default.forwardRef(function (_ref2, ref) {
  var gridGap = _ref2.gridGap,
      flexDirection = _ref2.flexDirection,
      children = _ref2.children,
      _ref2$container = _ref2.container,
      Container = _ref2$container === void 0 ? _View.default : _ref2$container,
      outerProps = (0, _objectWithoutProperties2.default)(_ref2, ["gridGap", "flexDirection", "children", "container"]);
  return (0, _core.jsx)(Container, (0, _extends2.default)({
    display: "flex",
    ref: ref,
    flexDirection: flexDirection
  }, outerProps), gridGap ? (0, _utils.joinChildren)(children, (0, _core.jsx)(GapSpacer, {
    flexDirection: flexDirection,
    gridGap: gridGap
  })) : children);
}); // Force TS to accept .withComponent


var FlexStyled = FlexBase;

FlexStyled.withComponent = function (tag) {
  var Container = _View.default.withComponent(tag, {
    target: "e1s41o6r1"
  });

  return _react.default.forwardRef(function (props, ref) {
    return (0, _core.jsx)(FlexBase, (0, _extends2.default)({}, props, {
      ref: ref,
      container: Container
    }));
  });
};

var FlexBaseWithDocs = (0, _stencilReactDesc.describe)(FlexStyled).description('View based on flex used for implementing layouts.');
FlexBaseWithDocs.propTypes = (0, _objectSpread2.default)({}, _View.default.describedPropTypes, {
  flexDirection: _stencilReactDesc.PropTypes.string.description("Sets the CSS 'flex-direction' property for the element.").isRequired,
  gridGap: (0, _propTypes.cssValue)().description('Spacing between each child.'),
  children: _stencilReactDesc.PropTypes.node.description('Elements to lay out horizontally.')
});
var Flex = (0, _utils.withTestAttributes)({
  component: 'StencilReactFlex'
})(FlexBaseWithDocs);
Flex.displayName = 'Flex';
var _default = Flex;
exports.default = _default;